import { render, staticRenderFns } from "./CustomDataTab.vue?vue&type=template&id=1dfc4fac&scoped=true"
import script from "./CustomDataTab.vue?vue&type=script&lang=js"
export * from "./CustomDataTab.vue?vue&type=script&lang=js"
import style0 from "./CustomDataTab.vue?vue&type=style&index=0&id=1dfc4fac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfc4fac",
  null
  
)

export default component.exports